import React from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { Breadcrumb, Button, Icon } from 'antd'
import { useFormikContext } from 'formik'

import { RULES, validRule } from '../../../../../../constants/Entitlements'
import { getMessage } from '../../../../../../util/IntlMessages'
import { isAdmin } from '../../../../../../util/profiles'
import { actionStatus, actionStatusMap } from '../../constants'
import { useCreateActionContext } from '../../contexts/action'

import './styles.less'

export function ActionHeader() {
  const params = useParams()
  const history = useHistory()

  const { currentUser, isNewAction, isPreview, setIsPreview, isReadOnly } = useCreateActionContext()

  const { submitForm, setValues, values } = useFormikContext()

  function confirmAction(action) {
    const isActionFinished = action === 'finish'
    if (isActionFinished) {
      const baseFields = {
        ...values.baseFields,
        finish: isActionFinished,
        actionStatusId: actionStatusMap.get(actionStatus.DONE)
      }

      setValues({ ...values, baseFields })
    }

    submitForm()
  }

  const hasAccess = validRule(RULES.ACTION)
  const sysAdmin = isAdmin(currentUser)

  return (
    <div className="actionHeader">
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => history.push('/')}>
          <Icon
            className="actionHeader__icon actionHeader__homeIcon"
            type="home"
            theme="filled"
            onClick={() => history.push('/')}
          />
        </Breadcrumb.Item>

        <Breadcrumb.Item className="actionHeader__breadcrumbItem" onClick={() => history.push('/actions/list')}>
          {getMessage('actions')}
        </Breadcrumb.Item>

        <Breadcrumb.Item className="actionHeader__breadcrumbItem">{`${params.id ? getMessage('updateAction') : getMessage('registerAction')}`}</Breadcrumb.Item>
      </Breadcrumb>

      <div className="actionHeader__buttonsWrapper">
        {isPreview ? (
          <>
            <Button className="actionHeader__btnReturn" onClick={() => setIsPreview(false)}>
              <Icon type="left" theme="outlined" className="actionHeader__icon" />
              {getMessage('reEdit')}
            </Button>

            <Button className="actionHeader__btnAction" type="primary" onClick={() => confirmAction('finish')}>
              {getMessage('finish')}
            </Button>
          </>
        ) : (
          <>
            <Button className="actionHeader__btnReturn" id="back" onClick={() => history.push('/actions/list')}>
              <Icon type="left" theme="outlined" className="actionHeader__backIcon" />
              {getMessage('back')}
            </Button>

            {(sysAdmin || (!isReadOnly && hasAccess)) && (
              <>
                <Button
                  className="actionHeader__btnAction"
                  id="save"
                  type="primary"
                  onClick={() => confirmAction('save')}
                >
                  {isNewAction ? getMessage('register') : getMessage('update')}
                </Button>

                <Button
                  className="actionHeader__btnAction"
                  id="finish"
                  type="primary"
                  onClick={() => confirmAction('finish')}
                >
                  {getMessage('finishAction')}
                </Button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  )
}
